import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";

const STATUSES = ["in_progress", "approved", "rejected", "on_hold", "completed"];
// BUG-67: critical added — matches submit-form chip set (T2TSubmit BUG-56)
const PRIORITIES = ["critical", "high", "medium", "low"];

export default function FilterPanel({ show, filters, onChange, onClose }) {
  const [local, setLocal] = useState(filters);

  // Sync local state when filters change externally (e.g. clear-all)
  useEffect(() => { setLocal(filters); }, [filters]);

  const set = useCallback((key, val) => setLocal(prev => ({ ...prev, [key]: val })), []);

  const apply = () => { onChange(local); onClose(); };
  const reset = () => {
    const empty = { status: "", priority: "", workflow_id: "", request_type_id: "", date_from: "", date_to: "" };
    setLocal(empty);
    onChange(empty);
    onClose();
  };

  const activeCount = Object.values(local).filter(Boolean).length;

  return (
    <>
      {/* Backdrop */}
      {show && (
        <div
          style={{ position: "fixed", inset: 0, zIndex: 1049 }}
          onClick={onClose}
        />
      )}

      {/* Drawer */}
      <div
        style={{
          position: "fixed", top: 0, right: show ? 0 : "-360px", width: 360,
          height: "100dvh", zIndex: 1050, background: "#fff",
          boxShadow: "-4px 0 24px rgba(0,0,0,0.12)",
          transition: "right 0.25s ease", display: "flex", flexDirection: "column",
        }}
      >
        {/* Header */}
        <div className="d-flex align-items-center justify-content-between px-4 py-3 border-bottom">
          <span className="fw-semibold" style={{ fontSize: 15 }}>
            Filters {activeCount > 0 && <span className="badge bg-primary ms-1">{activeCount}</span>}
          </span>
          <button className="btn btn-sm btn-light" onClick={onClose}>
            <i className="bi bi-x-lg" />
          </button>
        </div>

        {/* Body */}
        <div className="flex-grow-1 overflow-auto px-4 py-3 d-flex flex-column gap-4">

          {/* Status */}
          <FilterGroup label="Status">
            <div className="d-flex flex-wrap gap-2">
              {STATUSES.map(s => (
                <button
                  key={s}
                  type="button"
                  className={`btn btn-sm ${local.status === s ? "btn-primary" : "btn-outline-secondary"}`}
                  style={{ fontSize: 12 }}
                  onClick={() => set("status", local.status === s ? "" : s)}
                >
                  {s.replace(/_/g, " ")}
                </button>
              ))}
            </div>
          </FilterGroup>

          {/* Priority */}
          <FilterGroup label="Priority">
            <div className="d-flex flex-wrap gap-2">
              {PRIORITIES.map(p => (
                <button
                  key={p}
                  type="button"
                  className={`btn btn-sm ${local.priority === p ? "btn-primary" : "btn-outline-secondary"}`}
                  style={{ fontSize: 12 }}
                  onClick={() => set("priority", local.priority === p ? "" : p)}
                >
                  {p}
                </button>
              ))}
            </div>
          </FilterGroup>

          {/* Date range */}
          <FilterGroup label="Due Date Range">
            <div className="d-flex gap-2 align-items-center">
              <input
                type="date"
                className="form-control form-control-sm"
                value={local.date_from}
                onChange={e => set("date_from", e.target.value)}
              />
              <span className="text-muted small">to</span>
              <input
                type="date"
                className="form-control form-control-sm"
                value={local.date_to}
                onChange={e => set("date_to", e.target.value)}
              />
            </div>
          </FilterGroup>

        </div>

        {/* Footer */}
        <div className="px-4 py-3 border-top d-flex gap-2">
          <button className="btn btn-primary flex-grow-1" onClick={apply}>Apply</button>
          <button className="btn btn-outline-secondary" onClick={reset}>Reset</button>
        </div>
      </div>
    </>
  );
}

FilterPanel.propTypes = {
  show:    PropTypes.bool.isRequired,
  filters: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

function FilterGroup({ label, children }) {
  return (
    <div>
      <div className="fw-semibold mb-2" style={{ fontSize: 12, textTransform: "uppercase", letterSpacing: "0.05em", color: "#6b7280" }}>
        {label}
      </div>
      {children}
    </div>
  );
}

FilterGroup.propTypes = {
  label:    PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};
